import React, { useState, useRef } from 'react'

export default function ImageTemplate({setOpen, data, setData}) {
  const [ image, setImage ] = useState({
    url: "https://placehold.it/400x200",
    link: ""
  })

  const handleChange = async (e, where) => {
    setImage({...image, [where]: (e.target ? e.target.value : e.value)})
  }

  const hash = Math.random().toString(36).substring(7)
  const html = `
    <div class="image__template--${hash}">
      <a href="${image.link ? image.link : 'javascript:void(0);'}">
        <img src="${image.url}"/>
      </a>
      <div class="image__template--backdrop" onclick="this.parentNode.style.display = 'none'"></div>
    </div>
  `

  const css = `
    .image__template--${hash} {
      width: 100vw;
      height: 100vh;
      z-index: 9999;
      position: fixed;
      top: 0;
      left: 0;
    }

    .image__template--${hash} img {
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
      width: auto;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    .image__template--${hash} .image__template--backdrop {
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.75);
      position: absolute;
      top: 0;
      left: 0;
    }

    @media (max-width: 768px) {
      .image__template--${hash} img {
        width: 100%;
        height: auto;
      }
    }
  `

  const handleSave = () => {
    const arr = data.dispatcher ? data.dispatcher : [];
    
    setData({
      ...data,
      dispatcher: {
        ...arr,
        customHtml: html,
        customCss: css
      }
    });

    setOpen(false)
  }

  return (
    <>
      <div className="titled__group" style={{marginTop: "30px"}}>
        <p>URL da Imagem:</p>
        <input type="text" className="basic-input" defaultValue={image.url} onChange={(e) => handleChange(e, "url")}/>
      </div>
      <div className="titled__group" style={{marginTop: "30px"}}>
        <p>Link da Imagem:</p>
        <input type="text" className="basic-input" defaultValue={image.link} onChange={(e) => handleChange(e, "link")}/>
      </div>

      <div className="titled__group" style={{marginTop: "30px"}}>
        <p>Preview:</p>
        <div className="dcm__template-preview">
          {
            image.url ?
              <div className="image__template">
                <a href={image.link ? image.link : "javascript:void(0);"} target="_blank">
                  <img src={image.url}/>
                </a>

                <div className="image__template--backdrop"></div>
              </div>
            : null
          }
        </div>

        <button type="button" onClick={handleSave} className="btn btn-blue float-right" style={{marginTop: "30px"}}>Salvar</button>
      </div>
    </>
  )
}